import QuickMovementForm from "./QuickMovementForm";
export default function PurchaseForm() { return <QuickMovementForm type="purchase" />; }
